import styled from 'styled-components';

export const ProfilePic = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  background-color: ${({ theme }) => theme.color.grey90};
`;

export const Filter = styled.input`
  border: 1px solid #e8e8e8;
  border-radius: 4px;
`;
